import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class CfeErrorHandler implements ErrorHandler {
	constructor() {}

	handleError(error) {
		console.error('CfeErrorHandler - Uncaught Error:', error);
		throw error;
	}
}
